export const ERROR_PAGE_URL = '/oops';
export const NOT_FOUND_PAGE_URL = '/404/';
export const EMAIL_SENT_URL = '/login/userInactive/';
